import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';

import EventsList from '../../components/Events/EventsList';
import { sendStatus, fetchEvents } from '../../actions/events';


const mapStateToProps = (state, { params: { id/* , userId */ } }) => ({
  events: state.events.data.events,
  count: state.events.data.count,
  perPageItems: state.settings.events.rows,
  isPagination: state.settings.events.rows < state.events.data.count,
  loading: state.events.data.loading,
  timezone: (
    (id && state.students.data[parseInt(id, 10)] && state.students.data[parseInt(id, 10)].timezone)
    || (id === 'user' && state.user.timezone)
    || 'Europe/Moscow'
  ),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    sendStatus: status => dispatch(sendStatus(status)),
    fetchEvents: (...params) => dispatch(fetchEvents(...params)),
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),

  withState('page', 'setPage', 1),

  withHandlers({
    handleChangePage: ({ setPage }) => (page) => {
      setPage(page);
    },
    handleAppear: ({ actions }) => (id) => {
      actions.sendStatus({ id, read: true });
    },
  }),

  lifecycle({
    componentDidMount() {
      const { actions, params: { id, type }, perPageItems, page } = this.props;
      const fetchId = id === 'user' ? null : id;
      actions.fetchEvents(fetchId, type, (page - 1) * perPageItems, perPageItems);
    },
    // $FlowFixMe
    UNSAFE_componentWillReceiveProps(nextProps) {
      const { actions, params: { id, type }, perPageItems, page } = this.props;
      const {
        params: { id: nextId, type: nextType },
        perPageItems: nextPerPage,
        page: nextPage,
        handleChangePage,
      } = nextProps;
      const fetchId = nextId === 'user' ? null : nextId;
      if (nextPerPage !== perPageItems || nextId !== id || nextType !== type) {
        handleChangePage(1);
        actions.fetchEvents(fetchId, nextType, 0, nextPerPage);
      }
      if (nextPage !== page) {
        actions.fetchEvents(fetchId, nextType, (nextPage - 1) * nextPerPage, nextPerPage);
      }
    },
  }),

  mapProps(({ page, perPageItems, count, ...others }) => {
    const left = count - ((page - 1) * perPageItems);
    return ({
      page,
      perPageItems,
      count,
      begin: ((page - 1) * perPageItems) + 1,
      N: left > perPageItems ? perPageItems : left,
      ...others,
    });
  })
)(EventsList);
